import AOS from "./AOS/aos";
window.AOS = AOS;
document.addEventListener("DOMContentLoaded", (e) => {
	AOS.init({ once: true });

	setTimeout(() => {
		AOS.refresh();
	}, 150);
});
